import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faXmark,
  faPercent,
  faFileContract,
  faSave,
  faGaugeHigh,
  faUserPlus,
} from '@fortawesome/pro-solid-svg-icons';
import { RelationshipTypeService } from '../../../../../core/services/relationship-type.service';
import { RelationshipTypeDefault } from '../../../../../core/models/relationship-type.model';
import { SETTLEMENT_PERIODICITY_OPTIONS } from '../../../../../core/models/partner.model';
import { PopupInfoService } from '../../../../../shared/services/popup-info.service';
import { CustomSelectComponent } from '../../../../../shared/components/custom-select/custom-select.component';

@Component({
  selector: 'app-edit-relationship-default-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FontAwesomeModule, CustomSelectComponent],
  templateUrl: './edit-relationship-default-modal.html',
  styleUrls: ['./edit-relationship-default-modal.scss'],
})
export class EditRelationshipDefaultModal implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly relationshipTypeService = inject(RelationshipTypeService);
  private readonly popupInfoService = inject(PopupInfoService);

  @Input() relationshipType!: string;
  @Input() default!: RelationshipTypeDefault;
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<RelationshipTypeDefault>();

  faXmark = faXmark;
  faPercent = faPercent;
  faFileContract = faFileContract;
  faSave = faSave;
  faGaugeHigh = faGaugeHigh;
  faUserPlus = faUserPlus;

  settlementPeriodicityOptions = SETTLEMENT_PERIODICITY_OPTIONS;

  form: FormGroup;
  isLoading = false;

  constructor() {
    this.form = this.fb.group({
      fixed_commission: [null, [Validators.min(0), Validators.max(100)]],
      recurring_commission: [0, [Validators.required, Validators.min(0), Validators.max(100)]],
      operation_limit: [null, Validators.min(0)],
      settlement_periodicity: [''],
      min_new_clients_per_year: [null, Validators.min(0)],
    });
  }

  ngOnInit(): void {
    this.form.patchValue({
      fixed_commission: this.default.fixed_commission !== null ? Number(this.default.fixed_commission) : null,
      recurring_commission: Number(this.default.recurring_commission),
      operation_limit: this.default.operation_limit !== null ? Number(this.default.operation_limit) : null,
      settlement_periodicity: this.default.settlement_periodicity || '',
      min_new_clients_per_year:
        this.default.min_new_clients_per_year !== null
          ? Number(this.default.min_new_clients_per_year)
          : null,
    });
  }

  onClose(): void {
    this.close.emit();
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    const { settlement_periodicity, ...rest } = this.form.getRawValue();
    const data = {
      ...rest,
      settlement_periodicity: settlement_periodicity || null,
    };

    this.relationshipTypeService.updateDefault(this.default.id, data).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.popupInfoService.showSuccess('Condiciones actualizadas correctamente');
        this.success.emit(response.data);
      },
      error: () => {
        this.isLoading = false;
        this.popupInfoService.showError('Error al actualizar las condiciones');
      },
    });
  }
}
